import {Tab, Tabs} from '@customink/pigment-react';
import PropTypes from 'prop-types';
import React, {useRef} from 'react';
import {RELATED_PRODUCTS_TAB_KEY_YOU_MAY_ALSO_LIKE} from 'constants/pdpRelatedProducts';
import {
  EVENT_TYPE,
  fireTabbedViewEvent
} from 'utils/metrics/pdpRelatedStylesTabbedView';

const RelatedProductsTabs = ({
  activeTab = RELATED_PRODUCTS_TAB_KEY_YOU_MAY_ALSO_LIKE,
  onTabChange,
  tabs
}) => {
  const firstTabChange = useRef(true);
  const handleTabChange = (_event, value) => {
    fireTabbedViewEvent({
      activeTab: value,
      eventType: EVENT_TYPE.TAB_CHANGED,
      firstTabChange: firstTabChange.current,
      previousTab: activeTab
    });
    firstTabChange.current = false;
    onTabChange?.(value);
  };

  return (
    <Tabs
      sx={{
        '& .MuiTabs-indicator': {
          bottom: 0,
          height: '0.1875rem',
          zIndex: 1
        },
        '&::after': {
          bgcolor: 'grey.300',
          bottom: 0,
          content: '""',
          height: '0.125rem',
          left: 0,
          position: 'absolute',
          right: 0,
          zIndex: 0
        },
        borderBottom: 'none',
        margin: '1rem 0 1.25rem 0',
        position: 'relative'
      }}
      TabIndicatorProps={{
        sx: {
          bottom: '-0.125rem',
          height: 3
        }
      }}
      value={activeTab}
      onChange={handleTabChange}>
      {tabs.map((tab) => (
        <Tab label={tab.label} value={tab.value} key={tab.value} />
      ))}
    </Tabs>
  );
};

RelatedProductsTabs.propTypes = {
  activeTab: PropTypes.string,
  onTabChange: PropTypes.func,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired
};

export default RelatedProductsTabs;
